import { Attention } from "@warp-ds/react/components/attention";
import { useRef, useState } from "react";
import { AttentionProps } from "attention/src/props";

type TooltipProps = {
	placement?: AttentionProps["placement"];
	targetElement: React.ReactElement;
	children: React.ReactElement;
};

export const Tooltip = ({ targetElement, children, placement = "right" }: TooltipProps) => {
	const [showTooltip, setShowTooltip] = useState(false);
	const targetEl = useRef<HTMLDivElement>(null);

	return (
		<div>
			<div
				ref={targetEl}
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
				onFocus={() => setShowTooltip(true)}
				onBlur={() => setShowTooltip(false)}
			>
				{targetElement}
			</div>
			<Attention tooltip placement={placement} targetEl={targetEl} isShowing={showTooltip}>
				{children}
			</Attention>
		</div>
	);
};
